import { createRouter, createWebHistory } from 'vue-router'
import multiguard from 'vue-router-multiguard'
import middlewares from "@/x/middlewares"
import routes from "./routes"
const defaultRoutes = [
  // {
  //   path: '/',
  //   redirect: '/rebot'
  // },
  {
    path: '/rebot',
    name: 'rebot',
    meta: {
      title: "机器人"
    },
    component: () => import("@rebot/pages/index")
  },
  {
    path: '/rebot/v2',
    name: 'rebotV2',
    meta: {
      title: "机器人"
    },
    component: () => import("@rebot/pages/index_v2")
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: "登录"
    },
    component: () => import("@rebot/pages/login")
  },
  {
    path: '/wecomLogin',
    name: 'wecomLogin',
    meta: {
      title: "登录"
    },
    component: () => import("@rebot/pages/wecomLogin")
  },
]
const router = createRouter({
  history: createWebHistory('/rebot'),
  routes:[...defaultRoutes, ...routes]
})

router.beforeEach(multiguard([...middlewares]))

export default router